import { render } from "./ProductLegalComplianceInformation.vue?vue&type=template&id=66c084e3"
import script from "./ProductLegalComplianceInformation.vue?vue&type=script&lang=js"
export * from "./ProductLegalComplianceInformation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__